var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1123.5 464.3",
    style: {
      enableBackground: "new 0 0 1123.5 464.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00BCE4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M919.8,118.2c-79.2,0-143.1,63.9-143.1,143.1s63.9,143.1,143.1,143.1s143.1-63.9,143.1-143.1 S998.6,118.2,919.8,118.2z M919.8,393.8c-73.5,0-133-59.5-133-133s59.5-133,133-133s133,59.5,133,133S992.9,393.8,919.8,393.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M919.8,138.8c-67.8,0-122.5,54.7-122.5,122.5S852,383.8,919.8,383.8s122.5-54.7,122.5-122.5 S987.2,138.8,919.8,138.8z M919.8,373.3c-61.7,0-112.4-50.3-112.4-112.4s50.3-112.4,112.4-112.4s112.4,50.3,112.4,112.4 S981.5,373.3,919.8,373.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M919.8,158.9c-56,0-101.9,45.5-101.9,101.9c0,56,45.5,101.9,101.9,101.9c56,0,101.9-45.5,101.9-101.9 C1022.2,204.8,976.3,158.9,919.8,158.9z M919.8,352.7c-50.3,0-91.9-41.1-91.9-91.9c0-50.3,41.1-91.9,91.9-91.9 c50.3,0,91.9,41.1,91.9,91.9S970.1,352.7,919.8,352.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "782.9,123.5 771.1,123.5 615.8,386.8 461.3,123.5 449.1,123.5 615.8,407.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "777.2,90.2 765.4,90.2 615.8,346.2 485.4,123.5 473.6,123.5 615.8,366.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "771.1,57.4 759.3,57.4 615.3,304.2 509.9,123.5 497.6,123.5 615.8,324.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.1,393.8c-64.7,0-118.6-46.8-130.4-108.1h10.5c11.4,55.6,60.8,97.6,119.9,97.6 c46.8,0,87.5-26.2,108.1-64.8h-11.8c-19.7,32.4-55.1,54.2-96.2,54.2c-53.4,0-98-37.6-109.4-87.5h10.5 c10.9,44.2,50.7,77.4,98.9,77.4c34.6,0,65.6-17.5,84.4-44.2h-12.7c-16.6,21-42.4,34.1-71.3,34.1c-42,0-77.4-28.4-88.4-66.9h229.2 c1.3-8.3,1.8-16.2,1.8-24.9c0-79.2-63.9-143.1-143.1-143.1c-70,0-128.6,50.3-140.4,117.2H40v10.5h369.7c-7-49-49.9-86.6-101.1-86.6 c-47.7,0-87.5,32.4-98.9,76.6h-10.5c11.4-49.4,56-86.6,108.9-86.6c59.9,0,108.9,47.2,112,106.8H101.7v10.5h329c0-1.3,0-3.5,0-4.8 c0-67.8-54.7-122.5-122.5-122.5c-59.1,0-108.1,41.6-119.9,97.1h-10.5c11.8-60.8,65.6-107.2,129.9-107.2c73.5,0,133,59.5,133,133 c0,4.8-0.4,9.6-0.9,14.4H70.2v10.5h96.7c11.8,66.9,70.4,118.1,140.9,118.1c58.6,0,108.5-35.4,130.8-85.3h-11.4 C407.1,362.8,361.6,393.8,309.1,393.8z M309.1,169c42,0,77,28,87.9,66.1H221.1C232.1,197.4,267.5,169,309.1,169z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1042.3,381.2h-14.9c-0.9,0-1.8,0.4-1.8,1.3s0.4,1.3,1.8,1.3h5.7v16.6c0,0.9,0.4,1.8,1.3,1.8s1.8-0.4,1.8-1.8 v-16.6h5.7c0.9,0,1.3-0.4,1.3-1.3C1043.6,381.6,1043.2,381.2,1042.3,381.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1067.3,380.7c-0.9,0-1.3,0.4-1.8,0.9l-7,12.2l-7.4-12.2c-0.4-0.9-0.9-0.9-1.3-0.9c-0.9,0-1.8,0.4-1.8,1.8 v17.9c0,0.9,0.9,1.3,1.8,1.3s1.3-0.4,1.3-1.3v-13.1l0,0l6.1,10.5c0.4,0.4,0.9,0.9,1.3,0.9s0.9-0.4,1.3-0.9l6.1-10.5l0,0v13.1 c0,0.9,0.9,1.3,1.8,1.3s1.3-0.4,1.3-1.3v-17.9C1068.6,381.2,1068.1,380.7,1067.3,380.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.044bf5fabcae9808da12d3eeee9649bf.svg";
export { ForwardRef as ReactComponent };